<script setup lang="ts">
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import { useNotifications } from "@/notifications/useNotifications";
import { useRouter } from "vue-router";
import CanvassForm from "./CanvassForm.vue";
import { useCreateCanvass, useNewCanvass } from "./canvassesCrud";

const router = useRouter();

const { addPendingNotification } = useNotifications();
const { canvass } = useNewCanvass();
const {
  createCanvass,
  createCanvassStatus,
  error: createCanvassError,
} = useCreateCanvass({
  onSuccess: () => {
    addPendingNotification("Die Haustüraktion wurde erfolgreich gespeichert.");
    router.push({ name: "editCanvass", params: { id: canvass.value.id } });
  },
});
</script>

<template>
  <ManagementLayout
    :breadcrumbs="[
      { label: 'Haustüraktionen', to: { name: 'canvasses' } },
      { label: 'Haustüraktion planen' },
    ]"
  >
    <template #header>
      <h1>Haustüraktion planen</h1>
    </template>
    <CanvassForm
      :canvass="canvass"
      :updating-status="createCanvassStatus"
      :error="createCanvassError"
      @update="createCanvass"
    />
  </ManagementLayout>
</template>
